import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/about/bg1.png")